import { Badge } from "@acdc2/ui/components/badge";
import type { PageNumberBadgeFragment } from "../client/generated";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Badge> & {
  fragment: PageNumberBadgeFragment;
};

export function PageNumberBadge({ fragment, ...props }: Props) {
  return <Badge {...props}>{fragment.index}</Badge>;
}
